const baseEnvironment = process.env.REACT_APP_API_BASE_URL?.trim() || 'http://localhost:8010';
const API_BASE = baseEnvironment.replace(/\/$/, '');

const buildHeaders = () => {
  const token = sessionStorage.getItem('authToken');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const handleErrors = async (response, defaultMessage) => {
  if (response.ok) {
    return response.json();
  }
  const body = await response.json().catch(() => ({}));
  throw new Error(body.detail || body.message || defaultMessage || `Request failed (${response.status})`);
};

export async function fetchMonthlyIncomeExpenseReport(params) {
  const query = new URLSearchParams({
    companyId: String(params.companyId),
    periodId: String(params.periodId)
  });
  if (params.startDate) {
    query.set('startDate', params.startDate);
  }
  if (params.endDate) {
    query.set('endDate', params.endDate);
  }
  if (params.accountRangeStart) {
    query.set('accountRangeStart', params.accountRangeStart);
  }
  if (params.accountRangeEnd) {
    query.set('accountRangeEnd', params.accountRangeEnd);
  }
  const response = await fetch(`${API_BASE}/api/reports/monthly-income-expense?${query.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Aylik gelir-gider raporu alinamadi.');
}

export async function fetchMonthlyIncomeExpenseAccounts(companyId, periodId, search) {
  const query = new URLSearchParams({
    companyId: String(companyId),
    periodId: String(periodId)
  });
  if (search) {
    query.set('search', search);
  }
  const response = await fetch(`${API_BASE}/api/reports/monthly-income-expense/accounts?${query.toString()}`, {
    headers: buildHeaders()
  });
  return handleErrors(response, 'Gelir-gider hesap listesi alinamadi.');
}

const reportMonthlyIncomeExpenseService = {
  fetchMonthlyIncomeExpenseReport,
  fetchMonthlyIncomeExpenseAccounts
};

export default reportMonthlyIncomeExpenseService;
